import geneticCounsellingImg from "assets/img/stock/genetic-counselling.jpg";
import geneticCounsellingImg640 from "assets/img/stock/genetic-counselling-640.jpg";
import geneticCounsellingImg1080 from "assets/img/stock/genetic-counselling-1080.jpg";
import reproductiveRiskImg from "assets/img/stock/reproductive-risk.jpg";
import reproductiveRiskImg640 from "assets/img/stock/reproductive-risk-640.jpg";
import reproductiveRiskImg1080 from "assets/img/stock/reproductive-risk-1080.jpg";
import carrierScreeningImg from "assets/img/stock/carrier-screening.jpg";
import carrierScreeningImg640 from "assets/img/stock/carrier-screening-640.jpg";
import carrierScreeningImg1080 from "assets/img/stock/carrier-screening-1080.jpg";
import prenatalScreeningImg from "assets/img/stock/prenatal-screening.jpg";
import prenatalScreeningImg640 from "assets/img/stock/prenatal-screening-640.jpg";
import prenatalScreeningImg1080 from "assets/img/stock/prenatal-screening-1080.jpg";

export const SERVICES = [
  {
    key: "geneticCounselling",
    slug: "genetic-counselling",
    icon: "conversation",
    image: geneticCounsellingImg,
    imageSrcSet: `${geneticCounsellingImg640} 640w, ${geneticCounsellingImg1080} 1080w, ${geneticCounsellingImg} 1600w`,
    seo: {
      title: "Genetic Counselling",
      description: "Learn about our comprehensive genetic counselling services.",
      keywords: "genetic counselling, genetic testing, family health planning",
      canonicalUrl: "/genetic-counselling",
      ogUrl: "/genetic-counselling"
    }
  },
  {
    key: "reproductiveRisk",
    slug: "reproductive-risk",
    icon: "pedigree",
    image: reproductiveRiskImg,
    imageSrcSet: `${reproductiveRiskImg640} 640w, ${reproductiveRiskImg1080} 1080w, ${reproductiveRiskImg} 1600w`,
    seo: {
      title: "Reproductive Risk Assessment",
      description: "Learn about reproductive risk assessment.",
      keywords: "reproductive risk, genetic testing",
      canonicalUrl: "/reproductive-risk",
      ogUrl: "/reproductive-risk"
    }
  },
  {
    key: "carrierScreening",
    slug: "proactive-genetic-screening",
    icon: "helix",
    image: carrierScreeningImg,
    imageSrcSet: `${carrierScreeningImg640} 640w, ${carrierScreeningImg1080} 1080w, ${carrierScreeningImg} 1600w`,
    seo: {
      title: "Proactive Genetic Screening",
      description:
        "Carrier screening and hereditary cancer screening with a Canadian certified genetic counsellor, in English, Mandarin, or Cantonese.",
      keywords:
        "proactive genetic screening, expanded carrier screening, hereditary cancer screening, genetic testing",
      canonicalUrl: "/proactive-genetic-screening",
      ogUrl: "/proactive-genetic-screening"
    }
  },
  {
    key: "prenatalScreening",
    slug: "prenatal-screening",
    icon: "scan",
    image: prenatalScreeningImg,
    imageSrcSet: `${prenatalScreeningImg640} 640w, ${prenatalScreeningImg1080} 1080w, ${prenatalScreeningImg} 1200w`,
    seo: {
      title: "Prenatal Screening",
      description: "Learn about prenatal screening services.",
      keywords: "prenatal screening, genetic testing",
      canonicalUrl: "/prenatal-screening",
      ogUrl: "/prenatal-screening"
    }
  },
];

// Deliberately not in SERVICES. The landing page cards and the navbar's
// Services menu both map over that array, so anything added there shows up in
// both. These are reachable only by knowing the URL, and each one sits behind
// PasswordGate, which is a soft gate rather than a security control: read its
// header before assuming a page here is private.
//
// `noindex` is carried per entry rather than assumed, so the choice is visible
// at the point the page is declared.
export const HIDDEN_SERVICES = [
  {
    key: "hiddenScreening",
    slug: "hidden-screening",
    icon: "helix",
    image: carrierScreeningImg,
    imageSrcSet: `${carrierScreeningImg640} 640w, ${carrierScreeningImg1080} 1080w, ${carrierScreeningImg} 1600w`,
    noindex: true,
    gate: { id: "hiddenScreening", secret: "secret" },
    seo: {
      title: "Proactive Genetic Screening",
      description:
        "Carrier screening and hereditary cancer screening with a Canadian certified genetic counsellor, in English, Mandarin, or Cantonese.",
      keywords:
        "proactive genetic screening, expanded carrier screening, hereditary cancer screening, genetic testing",
      canonicalUrl: "/hidden-screening",
      ogUrl: "/hidden-screening"
    }
  },
  {
    key: "hiddenPrenatal",
    slug: "hidden-prenatal",
    icon: "scan",
    image: prenatalScreeningImg,
    imageSrcSet: `${prenatalScreeningImg640} 640w, ${prenatalScreeningImg1080} 1080w, ${prenatalScreeningImg} 1200w`,
    noindex: true,
    gate: { id: "hiddenPrenatal", secret: "secret" },
    seo: {
      title: "Prenatal Screening",
      description: "Learn about prenatal screening services.",
      keywords: "prenatal screening, genetic testing",
      canonicalUrl: "/hidden-prenatal",
      ogUrl: "/hidden-prenatal"
    }
  },
];

// Looks in both, so ServicePage renders a hidden page the same way it renders a
// listed one. Listing is a property of SERVICES, not of the page component.
export const getService = (key) =>
  SERVICES.find((s) => s.key === key) ||
  HIDDEN_SERVICES.find((s) => s.key === key);
